<template>
  <div>
    <div style="background:linear-gradient(90deg,#4f5bd5,#5f2c82);color:#fff;padding:24px 16px 12px 16px;border-radius:8px;margin-bottom:20px;font-size:18px;">
      欢迎来到墅梯智选文章管理后台！<br>
      您可以在此管理文章数据，支持文章发布、编辑、删除等功能。
    </div>
    <el-button type="primary" @click="openForm()" style="margin-bottom:16px">新增文章</el-button>
    <div v-if="loading" style="text-align:center;padding:40px 0;color:#888;">
      正在加载数据，请稍候...
    </div>
    <div v-else-if="error" style="text-align:center;padding:40px 0;color:#e74c3c;">
      数据加载失败，请检查网络或稍后重试。
      <el-button type="text" @click="getList">重试</el-button>
    </div>
    <el-table v-else-if="list.length > 0" :data="list" style="width: 100%">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="title" label="标题" min-width="200" />
      <el-table-column prop="category" label="分类" width="120" />
      <el-table-column prop="tags" label="标签" width="150" />
      <el-table-column prop="status" label="状态" width="80">
        <template #default="scope">
          <el-tag :type="scope.row.status === 'published' ? 'success' : 'info'">
            {{ scope.row.status === 'published' ? '已发布' : '草稿' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="views" label="浏览量" width="80" />
      <el-table-column prop="created_at" label="创建时间" width="180">
        <template #default="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button size="mini" @click="openForm(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-else style="text-align:center;padding:40px 0;color:#888;">
      暂无文章数据，请点击"新增文章"按钮添加。
    </div>
    
    <!-- 分页 -->
    <el-pagination
      v-if="total > 0"
      @current-change="handlePageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      style="margin-top: 20px; text-align: center;"
    />
    
    <article-form :visible.sync="formVisible" :data="formData" @refresh="getList" />
  </div>
</template>

<script>
import axios from 'axios';
import ArticleForm from './ArticleForm.vue';
export default {
  name: 'ArticleList',
  components: { ArticleForm },
  data() {
    return {
      list: [],
      loading: false,
      error: false,
      formVisible: false,
      formData: null,
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.error = false;
      try {
        const res = await axios.get('/api/admin/article', {
          params: {
            page: this.currentPage,
            limit: this.pageSize
          },
          headers: { Authorization: localStorage.getItem('token') }
        });
        this.list = res.data.data || [];
        this.total = res.data.total || 0;
      } catch (e) {
        this.error = true;
        this.list = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    openForm(row) {
      this.formData = row ? { ...row } : null;
      this.formVisible = true;
    },
    async onDelete(row) {
      this.$confirm('确定删除该文章吗？', '提示', { type: 'warning' })
        .then(async () => {
          await axios.delete(`/api/admin/article/${row.id}`, { headers: { Authorization: localStorage.getItem('token') } });
          this.$message.success('删除成功');
          this.getList();
        });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleString('zh-CN');
    }
  }
};
</script>